/**
 * Service worker registration with safe-by-default behaviour.
 *
 * - DEV: SW is skipped (CRA's dev server has its own HMR; double-cache breaks
 *   hot reload). We also actively *unregister* any prior SW + nuke caches so
 *   developers don't get poisoned by a previously-installed prod SW.
 * - PROD: register `/service-worker.js` after page load. On `updatefound`, the
 *   new SW activates next time all tabs are closed (no aggressive reload).
 */

const isLocalhost = Boolean(
  typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname)
  )
);

export function register() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  // In dev we never want a service worker — strip any stale registration.
  if (process.env.NODE_ENV !== 'production' || isLocalhost) {
    unregister();
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        console.info('[Forge] Service worker registered:', reg.scope);
      })
      .catch((err) => {
        console.warn('[Forge] Service worker registration failed:', err);
      });
  });
}

export function unregister() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
}
